<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
      <b-card :header="caption">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="teamsArray" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
          <template slot="name" slot-scope="data">
            <strong>{{data.item.val().name}}</strong>
          </template>
          <template slot="category" slot-scope="data">
            <strong>{{getCategoryName(data.item.val().category)}}</strong>
          </template>
          <template slot="created" slot-scope="data">
            <strong>{{new Date(data.item.val().created).toGMTString()}}</strong>
          </template>
          <template slot="modified" slot-scope="data">
            <strong>{{new Date(data.item.val().modified).toGMTString()}}</strong>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="teamsArray.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          <b-row class="align-items-center">
            <b-col cols="12" xl= "2" sm="2" md="2" class="mb-3 mb-xl-0" >
              <b-button v-on:click="addTeamButton" block variant="primary">Add Team</b-button>
            </b-col>
        </b-row>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { db } from '@/config/devowqlo';
import teamsData from './TeamsData'
export default {
  name: 'Teams',
  firebase: {
    teams: db.ref('teams'),
    categories: db.ref('categories')
  },
  props: {
    caption: {
      type: String,
      default: 'Teams'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      //items: teamsData.filter((team) => team.id < 10),
      // items: [],
      // items: this.$firebaseRefs.teams,
      // items: this.getTeams(),
      fields: [
        {key: 'name'},
        {key: 'category'},
        {key: 'created'},
        {key: 'modified'},
      ],
      teamsArray: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  created(){
    db.ref('teams').on('value', (snapshot) =>{
            
            this.teamsArray = []
            snapshot.forEach(categorySnapshot => {
              categorySnapshot.forEach(teamSnapshot => {
                console.log(teamSnapshot.val())
                this.teamsArray.push(teamSnapshot)
              })
              
            })
          })
  },
  methods: {
    getCategoryName(categoryId){
      var categoryName = ''
      this.categories.forEach(element => {
       if(element['.key'] == categoryId){
         categoryName = element.name
       }
      });
      return categoryName
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (teams) {
      console.log(teams)
      return teams.length
      // var teamsCountRef = this.$firebaseRefs.teams.child('count');
      // teamsCountRef.once('value', function(snapshot) {
      //   console.log(snapshot.val())
      //   return snapshot.val()
      // });
    },
    // getTeamsCount(){
    //   var teamsCountRef = this.$firebaseRefs.teams.child('count');
    //   teamsCountRef.on('value', function(snapshot) {
    //     console.log(snapshot.val())
    //     return snapshot.val()
    //   });
    // },
    teamLink (id) {
      return `teams/${id}`
    },
    rowClicked (team) {
      console.log(team)
      const teamLink = this.teamLink(team.key)
      this.$router.push({path: teamLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addTeamButton () {
      this.$router.push({path: 'teams/addteam'})
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
